import { Filter, FilterData } from "./filter";

export interface StringFilterProps {
    type: "string";
    name: string;
    label: string;
    initialValue?: string;
    row?: string;
}

export interface StringFilterReturn {
    type: "string";
    key: string;
    name: string;
    label: string;
    value: string;
    initialValue: string;
    active: boolean;
    getCriteria: () => string;
    row?: string;
}

export class StringFilter extends Filter {
    name: string;
    label: string;
    initialValue: string;
    row?: string;

    constructor({ name, label, initialValue = "", row }: StringFilterProps) {
        super();
        this.name = name;
        this.label = label;
        this.initialValue = initialValue;
        this.row = row;
    }

    public getInitialValues(result: FilterData): void {
        result[this.name] = this.initialValue;
    }

    public getFilter(filterData: FilterData): StringFilterReturn {
        const value = this.getValue(filterData);

        return {
            key: this.name,
            name: this.name,
            label: this.label,
            value: value,
            initialValue: this.initialValue,
            active: value !== this.initialValue,
            type: "string",
            getCriteria: () => this.getCriteria(filterData)
        };
    }

    public parse(filterData: FilterData, result: FilterData): void {
        const value = this.getValue(filterData);
        if (value !== this.initialValue) result[this.name] = value;
    }

    public getCriteria(filterData: FilterData): string {
        const value = this.getValue(filterData);
        const active = value !== this.initialValue;
        if (!active) return "";
        return `${this.label} con "${this.getValue(filterData)}"`
    }

    private getValue(filterData: FilterData): string {
        return String(filterData[this.name] || this.initialValue);
    }
}